import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BlogService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient,
        private sanitizer: DomSanitizer
    ) {}

    getData(){
        let url = `${this.API_URL}/blog-posts?populate=*&sort=updatedAt:DESC`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }
    
    getData2(){
        let url = `${this.API_URL}/blog?populate=*&sort=updatedAt:DESC`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

    getNewsPlaylistVideos(maxResults = 6) {
      const url = `${environment.API_URL}/youtube/news-playlist?maxResults=${maxResults}`;
      
      return this.http.get<any[]>(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}}).pipe(
        map((items) =>
          items.map((item: any) => ({
            title: item.title,
            date: item.date,
            badge: item.badge,
            videoId: item.videoId,
            safeUrl: this.getSafeUrl(item.videoId),
          }))
        )
      );
    }

    private getSafeUrl(videoId: string): SafeResourceUrl {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}`
      );
    }
}